import {NgModule, ModuleWithProviders} from '@angular/core';
import {ChartsModule} from 'ng2-charts';
import {AngularDateTimePickerModule} from 'angular2-datetimepicker';

import {SharedModule} from '../shared/shared.module';

// MODULES
const MODULES = [
    SharedModule,
    MasterRoutingModule,
    ChartsModule,
    AngularDateTimePickerModule
];

// MODULES_WITH_PROVIDERS
const MODULES_WITH_PROVIDERS: ModuleWithProviders[] = [];

// COMPONENTS
import {DashboardComponent} from './components/dashboard/dashboard.component';
import {NgCircleProgressModule} from 'ng-circle-progress';
import {LazyLoadImageModule} from 'ng-lazyload-image';
import {MasterRoutingModule} from './master-routing.module';
import {ProfilesComponent} from './components/profiles/profiles.component';
import {SettingsComponent} from './components/settings/settings.component';
import {ProfilesCreateModalComponent} from './components/profiles-create/profiles-create.component';
import {ProfilesRecoveryModalComponent} from './components/profiles-recovery/profiles-recovery.component';
import {ProfilesSettingsComponent} from './components/profiles-settings/profiles-settings.component';
import {MasterPersonalInfoSectionComponent} from './components/personal-info-section/personal-info-section.component';
import {MasterTrainingInfoSectionComponent} from './components/training-info-section/training-info-section.component';
import {MasterBodySectionComponent} from './components/body-section/body-section.component';
import {MealsComponent} from './components/meals/meals.component';
import {MealsModule} from '../meals/meals.module';
import {MasterMealOverwriteSectionComponent} from './components/meal-overwrite-section/meal-overwrite-section.component';
import {MessagesComponent} from './components/messages/messages.component';
import {SubscriptionsComponent} from './components/subscriptions/subscriptions.component';
import {SubscriptionsNewComponent} from './components/subscriptions/new/subscriptions-new.component';
import {SubscriptionsEditComponent} from './components/subscriptions/edit/subscriptions-edit.component';
import {NotesComponent} from './components/notes/notes.component';
import {NotesEditComponent} from './components/notes/edit/notes-edit.component';
import {NotesNewComponent} from './components/notes/new/notes-new.component';
import {NgxSummernoteModule} from 'ngx-summernote';
import {MacrosComponent} from './components/macros/macros.component';
import {MasterInBodyComponent} from './components/inbody/inbody.component';
import {ViewNoteComponent} from './components/notes/view-note/view-note.component';
import {ProfilesSendLoginModalComponent} from './components/profiles-send-login/profiles-send-login.component';
import {NutrientsComponent} from './components/nutrients/nutrients.component';
import {StatisticsComponent} from './components/statistics/statistics.component';
import {ViewRecipeStatisticsComponent} from './components/statistics/view-recipe/view-recipe-statistics.component';
import {AutoRecipesComponent} from './components/auto-recipes/auto-recipes.component';
import {AutoRecipesCreateComponent} from './components/auto-recipes/auto-recipes-create.component';
import {AutoRecipesEditComponent} from './components/auto-recipes/auto-recipes-edit.component';
import {DailyMacroChangeComponent} from './components/daily-macro-change/daily-macro-change.component';
import {DailyMacroChangeFormModalComponent} from './components/daily-macro-change-form/daily-macro-change-form.component';

// ENTRY COMPONENTS
const ENTRY_COMPONENTS = [];

// COMPONENTS
const COMPONENTS = [
    ...ENTRY_COMPONENTS,
    DashboardComponent,
    ProfilesComponent,
    AutoRecipesComponent,
    AutoRecipesCreateComponent,
    AutoRecipesEditComponent,
    StatisticsComponent,
    SettingsComponent,
    ProfilesCreateModalComponent,
    ProfilesRecoveryModalComponent,
    DailyMacroChangeComponent,
    DailyMacroChangeFormModalComponent,
    ViewRecipeStatisticsComponent,
    ProfilesSendLoginModalComponent,
    MasterTrainingInfoSectionComponent,
    MasterBodySectionComponent,
    MealsComponent,
    ProfilesSettingsComponent,
    MasterPersonalInfoSectionComponent,
    MasterMealOverwriteSectionComponent,
    MessagesComponent,
    NutrientsComponent,
    SubscriptionsComponent,
    SubscriptionsNewComponent,
    SubscriptionsEditComponent,
    NotesComponent,
    NotesEditComponent,
    NotesNewComponent,
    MacrosComponent,
    MasterInBodyComponent,
    ViewNoteComponent,
];

// EVENT EMITTERS
const EVENT_EMITTERS = [];

// SERVICES
const SERVICES = [];

// DIRECTIVES
const DIRECTIVES = [];

// PIPES
const PIPES = [];

@NgModule({
    imports: [
        ...MODULES,
        ...MODULES_WITH_PROVIDERS,
        NgCircleProgressModule,
        LazyLoadImageModule,
        MealsModule,
        NgxSummernoteModule
    ],
    declarations: [
        ...COMPONENTS,
        ...DIRECTIVES,
        ...PIPES
    ],
    providers: [
        ...SERVICES,
        ...EVENT_EMITTERS
    ],
    entryComponents: [
            ProfilesCreateModalComponent,
    ProfilesRecoveryModalComponent,
    DailyMacroChangeComponent,
    DailyMacroChangeFormModalComponent,
    ViewRecipeStatisticsComponent,
    ProfilesSendLoginModalComponent,
    ViewNoteComponent
    ]
})
export class MasterModule {
}
